
export const columns = [
  {
    title: '序号',
    width: '50px',
    customRender: ({ index }) => index + 1
  },
  {
    title: '关联ID',
    width: '120px',
    dataIndex: 'RelId'
  },
  {
    title: '账号ID',
    width: '120px',
    dataIndex: 'ShopId'
  },
  {
    title: '昵称',
    width: '160px',
    dataIndex: 'ShopName',
    align: 'left'
  },
  {
    title: '授权应用',
    width: '150px',
    slots: { customRender: 'appName' }
  },
  {
    title: '授权状态',
    width: '150px',
    dataIndex: 'StatusStr',
    slots: { customRender: 'statusStr' },
    align: 'left'
  },
  {
    title: '应用过期时间',
    width: '180px',
    dataIndex: 'AppExpiresIn',
    slots: { customRender: 'appExpiresIn' }
  },
  {
    title: '操作',
    slots: { customRender: 'operate' }
  }
]


